import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import sessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import cacheService from '@bingads-webui-static-legacy/cache-service';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import * as filterPreferences from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import appConfig from '@bingads-webui-component-legacy/config/index';
import { AssetGroup } from '@bingads-webui-campaign/campaign-ui-schemas';

export function getFilterConfig({
  i18n,
  preferenceService,
  isMobileAppCampaign,
}) {
  const legacyGlobalI18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
  const schemaI18nCampaign = window.globalLegacyI18n.get('$/schema-i18n!campaign');
  const preferenceStoreFactory = filterPreferences.getFilters;
  const entitySchema = AssetGroup;

  const filterConfig = getCommonFilterConfig({
    updatePilot: true,
    preferenceService,
    featureName: 'AppAdsAssetGroupGrid',
    entitySchema,
    i18n,
    legacyGlobalI18n,
    sessionStore,
    preferenceStoreFactory,
    globalConfig: appConfig,
    schemaI18nCampaign,
    cacheService,
    dataContextManager,
    jsdata: jsData,
    editor: {},
    extraConfigForSchemaProcessor: {
      isMobileAppCampaign,
    },
    selector: [{
      property: 'Status',
      defaultValue: null,
      removable: false,
      items: [
        {
          text: i18n.getString(_TL_('All asset groups')),
          value: null,
        },
        {
          text: i18n.getString(_TL_('All enabled asset groups')),
          value: ["Enum.AssetGroupStatus'Active'"],
        },
      ],
    }],
  });

  return filterConfig;
}
